const MenuOverflow = {
    el: {},

    resize(el) {
        this.el = $('[method="renderMenu"]');
        if (!this.el.length) return;

        this.el.each((i, el) => {
            this.kill($(el))
            this.resizeItem($(el));
        })
    },

    resizeItem(el) {
        // console.log('UL', el.find('nav ul'), el.find('nav ul').outerWidth(),);
        // console.log('BLOCK', el.parent(), el.parent().innerWidth());
        if (el.find('nav ul').outerWidth() > el.parent().innerWidth()) {
            this.shrinkHorizontal(el)
        } else if (el.find('nav ul').outerHeight() > el.parent().outerHeight()) {
            this.shrinkVertical(el)
        }
    },

    shrinkHorizontal(el) {
        console.log('shrinkHorizontal', el)
        const width = el.parent().outerWidth() - 64;
        el.find('nav > ul > li').each((i, li) => {
            if (($(li).position().left + $(li).outerWidth()) > width) {
                this.create($(li));
                return false;
            }
        })
    },

    shrinkVertical(el) {
        const height = el.parent().outerHeight();
        console.log('shrinkVertical', el, height)
        el.find('nav > ul > li').each((i, li) => {
            if (($(li).position().top + $(li).outerHeight()) > height) {
                this.create($(li));
                return false;
            }
        })
    },

    create(li) {
        const items = li.nextAll('li');
        // console.log(items)
        const wrapper =
            $('<div class="overflow">' +
                '<div icon="more_horiz"></div>' +
                '<ul class="holder"></ul> ' +
                '</div>')
                .insertBefore(li);
        li.appendTo(wrapper.find('.holder'));
        items.appendTo(wrapper.find('.holder'));
    },

    kill(el) {
        const overflow = el.find('.overflow');
        if (!overflow.length) return;

        console.log(overflow)

        overflow.find('>[icon]').remove();
        overflow.find('li:first').unwrap();
        overflow.find('li:first').unwrap();
    }
}

export default MenuOverflow;